import { QueryClient } from 'react-query'
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental'
import { persistQueryClient } from 'react-query/persistQueryClient-experimental'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0, // TODO: See if this can safely increase to ~1-10 minutes without breaking anything.
      notifyOnChangeProps: 'tracked',
    },
  },
})

// defaultLongCacheTime is used for queries where we allow optimistic loading behavior from cache with pop-in.
export const defaultLongCacheTime = 1000 * 60 * 60 * 24 * 3 // 3 days

const localStoragePersistor = createWebStoragePersistor({ storage: window.localStorage })

persistQueryClient({
  queryClient,
  persistor: localStoragePersistor,
})

export default queryClient
